import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const ListArchivedRoomsApi = createAsyncThunk('chat-room/archived-rooms', async ({ mainUserId, business_id, page = 1, limit = 10 }, { getState, rejectWithValue }) => {
  const { loginToken } = getState();
  const authToken = loginToken?.response?.token;
  try {
    const response = await fetch(
      `${ROOT_URL}/chat-room/archived-rooms?mainUserId=${mainUserId}&business_id=${business_id}&page=${page}&limit=${limit}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response);
  }
}
);


const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const ListArchivedRooms = createSlice(
  {
    name: 'ListArchivedRooms',
    initialState,
    reducers: {},
    extraReducers: {
      [ListArchivedRoomsApi.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [ListArchivedRoomsApi.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        response: action.payload,
      }),
      [ListArchivedRoomsApi.rejected]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      }),
    },
  },
);

export default ListArchivedRooms;
